import { constants } from '../constants';
const messages = {
    NETWORK_ERROR: constants.api_error_network_error,
    TIMEOUT: constants.api_error_timeout,
    CORS_ERROR: constants.api_error_cors_error,
    UNAUTHORIZED: constants.api_error_unauthorized,
    FORBIDDEN: constants.api_error_forbidden,
    NOT_FOUND: constants.api_error_not_found,
    BAD_REQUEST: constants.api_error_bad_request,
    RATE_LIMITED: constants.api_error_rate_limited,
    SERVER_ERROR: constants.api_error_server_error,
    NAME_DUPLICATION: constants.api_error_name_duplication,
    MANDATORY_FIELDS_MISSING: constants.api_error_mandatory_fields_missing,
    SERVICE_UNAVAILABLE: constants.api_error_service_unavailable
};
export const apiError = Object.fromEntries(Object.entries(messages).map(([k, v]) => [k, { key: k, message: v }]));
